import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import svgLogo from '../../assets/svg/lb-logo-2048.svg';

export const Wrapper = styled.nav`
  background-color: ${p => p.theme.color.whiteTrue};
  border-bottom: 1px solid ${p => p.theme.color.grayLight};
  left: 0;
  right: 0;
  position: fixed;
  top: ${p => (p.makeSpaceForNotificationBar ? '30px' : '0')};
  z-index: 11999;
  margin-bottom: ${p => p.theme.spacing(6)};

  @media (${p => p.theme.mq.desktop}) {
    flex-direction: row;
    position: static;
  }
`;

export const InnerWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 58px;
  margin: 0 auto;
  max-width: ${p => p.theme.base.pageWidth};
  padding: 0 ${p => p.theme.base.spacing.regular};
  width: 100%;

  @media (${p => p.theme.mq.desktop}) {
    height: 78px;
    justify-content: space-between;
    padding: 0 ${p => p.theme.base.spacing.huge};
    width: auto;
  }
`;

export const Logo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 30px;

  & > * + * {
    margin-left: ${p => p.theme.spacing(4)};
  }
`;

export const LBLogo = styled.div`
  height: 30px;
  width: 30px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${svgLogo});
`;

export const LogoItem = styled.a`
  color: ${p => p.theme.color.grayDark};
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
  position: relative;

  @media (${p => p.theme.mq.desktop}) {
    font-size: 16px;
    line-height: 1.2;
  }

  ${p =>
    p.primary &&
    css`
      @media (${p.theme.mq.mobile}) {
        display: ${p.showOnMobile ? 'static' : 'none'};
      }

      svg {
        fill: ${p.theme.color.blue};
        height: 20px;
      }
    `};
  ${p =>
    !p.primary &&
    css`
      &:before {
        border-left: 2px solid ${p.theme.rgba('grayDark', 0.5)};
        content: '';
        height: 30px;
        position: absolute;
        left: -${p.theme.spacing(2.5)};
        top: -6px;

        @media (${p.theme.mq.desktop}) {
          height: 30px;
        }
      }
    `};

  @media (${p => p.theme.mq.desktop}) {
    font-size: 18px;
  }
`;

export const NavItems = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: column;

  @media (${p => p.theme.mq.desktop}) {
    flex-direction: row;
  }
`;

export const NavItem = styled(NavLink)`
  color: ${p => p.theme.color.graySemiDark};
  cursor: pointer;
  display: none;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  text-decoration: none;
  transition: all 0.3s;

  &:after {
    border-bottom: 2px solid transparent;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    transform: translateY(3px);
    transition: 0.3s border, 0.3s transform;
  }

  &:hover {
    color: ${p => p.theme.color.grayDark};
  }

  &:hover:after {
    border-bottom-color: ${p => p.theme.color.blue};
    transform: translateY(0);
  }

  @media (${p => p.theme.mq.desktop}) {
    display: inline-block;
  }
`;

export const ExternalNavItem = styled.a.attrs({
  href: p => (p.to ? p.to : '/'),
})`
  color: ${p => p.theme.color.graySemiDark};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  text-decoration: none;
  transition: all 0.3s;

  &:after {
    border-bottom: 2px solid transparent;
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    transform: translateY(3px);
    transition: 0.3s border, 0.3s transform;
  }

  &:hover {
    color: ${p => p.theme.color.grayDark};
  }

  &:hover:after {
    border-bottom-color: ${p => p.theme.color.blue};
    transform: translateY(0);
  }

  @media (${p => p.theme.mq.desktop}) {
    display: inline-block;
  }

  @media (${p => p.theme.mq.mobile}) {
    width: 14ch;
    font-size: 12px;
    text-align: center;
    line-height: 12px;
    position: absolute;
    top: 11px;
    right: 14px;
    border: 1px solid #666;
    border-radius: 3px;
    padding: 5px;

    ${p =>
      !p.showMobile &&
      css`
        display: none;
      `};
  }
`;

export const BurgerWrapper = styled.div`
  height: 18px;
  margin: 0 5px;
  width: 25px;

  ${p =>
    p.hidden &&
    css`
      display: none;
    `}

  @media (${p => p.theme.mq.desktop}) {
    display: none;
  }
`;

export const ShowMobileStatusButton = styled.div`
  width: 10ch;
  text-align: center;
  line-height: 12px;
  position: absolute;
  top: 19px;
  right: 14px;
  border: 1px solid #666;
  border-radius: 3px;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;

    color: ${p => p.theme.color.graySemiDark};

  ${p =>
    !p.show &&
    css`
      display: none;
    `}

  @media (${p => p.theme.mq.desktop}) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Navbar/styles.js